import { BaseService } from './../base'
export class TypeIndicatorService extends BaseService {
    static get entity () {
        return 'type_indicator'
    }
    static get name () {
        return 'type_indicator'
    }
}